import { useState } from "react";
import Icon from "common/components/icons";
import {
  AttachButton,
  Button,
  ButtonsContainer,
  EmojiButton,
  IconsWrapper,
  Input,
  InputWrapper,
  MicButton,
  SendMessageButton,
  Wrapper,
} from "./styles";

const attachButtons = [
  { icon: "attachRooms", label: "Choose room" },
  { icon: "attachContacts", label: "Choose contact" },
  { icon: "attachDocument", label: "Choose document" },
  { icon: "attachCamera", label: "Use camera" },
  { icon: "attachImage", label: "Choose image" },
];

export default function Footer() {
  const [showIcons, setShowIcons] = useState(false);
  const [message, setMessage] = useState("");
  const hasMessage = message.trim().length > 0;

  return (
    <Wrapper>
      <IconsWrapper>
        <AttachButton onClick={() => setShowIcons(!showIcons)}>
          <Icon id="plus" className="icon" />
        </AttachButton>
        <ButtonsContainer>
          {attachButtons.map((btn) => (
            <Button showIcon={showIcons} key={btn.label}>
              <Icon id={btn.icon} />
            </Button>
          ))}
        </ButtonsContainer>
      </IconsWrapper>
      <InputWrapper>
        <Input
          placeholder="כתיבת הודעה"
          value={message}
          onChange={(event) => setMessage(event.target.value)}
        />
        <EmojiButton>
          <Icon id="smiley" className="icon" />
        </EmojiButton>
      </InputWrapper>
      {hasMessage ? (
        <SendMessageButton>
          <Icon id="send" className="icon" />
        </SendMessageButton>
      ) : (
        <MicButton>
          <Icon id="microphone" className="icon" />
        </MicButton>
      )}
    </Wrapper>
  );
}
